<template>
  <div class="hello">
    <el-dialog title="招生计划" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column property="year" label="年份" width="150"></el-table-column>
        <el-table-column property="school_name" label="专业名称" width="200"></el-table-column>
        <el-table-column property="num" label="招生人数"></el-table-column>
        <el-table-column property="money_year" label="费用"></el-table-column>
        <el-table-column property="major_detail" label="说明"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        gridData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }],
        dialogTableVisible: false,
      }
    },
    props: {
      data: {
        type: Array,
        required: true,
      }
    },
    created() {
      this.$http.schoolEnrollPlan({
        school_id: "1924",
        major_name: "光电信息科学与工程"
      }).then(res => {
        this.gridData = res.data.list
      })
    }
  }
</script>

<style scoped>
  .hello {}
</style>



// WEBPACK FOOTER //
// src/components/zhaoshengplan.vue